import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import API_URL from "../../src/Config";
import Tooltip from "@mui/material/Tooltip";
import { IoMdArrowBack } from "react-icons/io";
import { FiEye, FiDownload } from "react-icons/fi";
import "./Manpowerhistory.css";

const ManPowerJoiningHistory = ({ isSidebarExpanded }) => {
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const authKey = localStorage.getItem("authKey");
        const response = await axios.get(
          `${API_URL}/api/v1/man_power_joining_history/${id}`,
          {
            headers: {
              Authorization: authKey,
            },
          },
        );
        setHistoryData(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleBackProject = () => {
    navigate(-1);
  };

  // const handleViewAttachment = (fileId) => {
  //   // Open file in new tab
  //   window.open(`${API_URL}/api/view/man_power_attachment/${fileId}`, "_blank");
  // };

  const handleViewAttachment = async (fileId) => {
    try {
      const authKey = localStorage.getItem("authKey");
      const viewUrl = `${API_URL}/api/view/man_power_attachment/${fileId}`;

      const response = await axios.get(viewUrl, {
        headers: {
          Authorization: authKey,
        },
        responseType: "blob",
      });

      const contentType =
        response.headers["content-type"] || "application/octet-stream";

      const blob = new Blob([response.data], { type: contentType });
      const fileURL = window.URL.createObjectURL(blob);

      const newWindow = window.open("", "_blank");

      if (contentType.startsWith("image/")) {
        newWindow.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>Image Preview</title>
              <style>
                body { 
                  margin: 0; 
                  padding: 20px; 
                  display: flex; 
                  justify-content: center; 
                  align-items: center; 
                  min-height: 100vh;
                  background-color: #f0f0f0;
                }
                img { 
                  max-width: 100%; 
                  max-height: 100vh; 
                  object-fit: contain;
                  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
                }
              </style>
            </head>
            <body>
              <img src="${fileURL}" alt="File Preview" />
            </body>
          </html>
        `);
      } else if (contentType === "application/pdf") {
        newWindow.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>PDF Preview</title>
              <style>
                body { margin: 0; padding: 0; }
                iframe { width: 100%; height: 100vh; border: none; }
              </style>
            </head>
            <body>
              <iframe src="${fileURL}" type="application/pdf"></iframe>
            </body>
          </html>
        `);
      } else if (contentType.startsWith("text/")) {
        const text = await response.data.text();
        newWindow.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>Text Preview</title>
              <style>
                body { 
                  font-family: monospace; 
                  padding: 20px; 
                  background-color: #f8f8f8;
                  line-height: 1.4;
                }
                pre { 
                  white-space: pre-wrap; 
                  word-wrap: break-word; 
                }
              </style>
            </head>
            <body>
              <pre>${text}</pre>
            </body>
          </html>
        `);
      } else {
        newWindow.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>File Preview</title>
              <style>
                body { 
                  font-family: Arial, sans-serif; 
                  padding: 20px; 
                  text-align: center;
                  background-color: #f0f0f0;
                }
                .container {
                  max-width: 400px;
                  margin: 50px auto;
                  padding: 30px;
                  background: white;
                  border-radius: 8px;
                  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                }
                .download-btn {
                  background-color: #007bff;
                  color: white;
                  padding: 10px 20px;
                  border: none;
                  border-radius: 4px;
                  cursor: pointer;
                  text-decoration: none;
                  display: inline-block;
                  margin-top: 20px;
                }
                .download-btn:hover {
                  background-color: #0056b3;
                }
              </style>
            </head>
            <body>
              <div class="container">
                <h3>File Preview</h3>
                <p>This file type cannot be previewed directly.</p>
                <p>Content Type: ${contentType}</p>
                <a href="${fileURL}" download class="download-btn">Download File</a>
              </div>
            </body>
          </html>
        `);
      }

      newWindow.document.close();

      setTimeout(() => {
        window.URL.revokeObjectURL(fileURL);
      }, 10000);
    } catch (error) {
      console.error("Error viewing file:", error);
    }
  };

  const handleDownloadAttachment = async (fileId, filename) => {
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(
        `${API_URL}/api/download/man_power_attachment/${fileId}`,
        {
          headers: {
            Authorization: authKey,
          },
          responseType: "blob",
        },
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const formatDateTimeIST = (dateString) => {
    if (!dateString) return "NA";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "NA";

    return date.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div
      className={`data-list-content-container page-content ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="data-edit-form-header">
        <div className="data-edit-form-header-content">
          <div className="data-edit-form-heading-content-left-side">
            <Tooltip title="Back" arrow>
              <IoMdArrowBack
                className="back-company"
                onClick={handleBackProject}
              />
            </Tooltip>
            Man Power History (Status + Attachments)
          </div>
        </div>
      </div>

      <div className="header-separator"></div>

      <table>
        <thead>
          <tr>
            <th>Status</th>
            <th>Updated At</th>
            <th>Attachments</th>
          </tr>
        </thead>
        <tbody>
          {historyData.map((history, index) => (
            <tr key={index}>
              <td>{history.status}</td>
              {/* <td>{new Date(history.updated_at).toLocaleString()}</td> */}
              <td>{formatDateTimeIST(history.updated_at)}</td>

              <td>
                {history.files && history.files.length > 0 ? (
                  <div className="history-files-container">
                    {history.files.map((file, idx) => (
                      <div
                        className="manpower-uploaded-file-card"
                        key={`${file.file_id}-${idx}`}
                      >
                        <div className="file-info">
                          <div className="file-name">
                            File:
                            <span className="filename_span">
                              {file.filename || "Attachment"}
                            </span>
                          </div>
                          <div className="file-meta">
                            {/* {file.file_type?.toUpperCase()} |{" "} */}
                            {(file.file_size / 1024).toFixed(2)} KB
                          </div>
                        </div>
                        <div className="file-actions">
                          <button
                            className="file-action-btn"
                            onClick={() => handleViewAttachment(file.file_id)}
                          >
                            <FiEye /> View
                          </button>
                          <button
                            className="file-action-btn"
                            onClick={() =>
                              handleDownloadAttachment(
                                file.file_id,
                                file.filename,
                              )
                            }
                          >
                            <FiDownload /> Download
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <span>No Attachments</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ManPowerJoiningHistory;
